import React from 'react';
import { Col, Form, FormGroup, Button } from 'reactstrap';
import Papa from 'papaparse';

const R = require('ramda');

class GPA extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      filename: '',
      csv: null,
      csvError: false,
      updating: false,
      foundCount: '',
      skipCount: ''
    }
    this.onGPAClick = this.onGPAClick.bind(this)
    this.onChange = this.onChange.bind(this)
    this.STU_ID = 0;
    this.AC_GPA = 5;
    this.CIT_GPA = 6;
  }

  onChange(evt) {
    let _this = this
    let reader = new FileReader();
    reader.onload = function(){
      let csvText = reader.result
      let {data, errors} = Papa.parse(csvText);
      let csv = R.map(stu => ({
        stuID: stu[_this.STU_ID],
        acGPA: stu[_this.AC_GPA],
        citGPA: stu[_this.CIT_GPA]
      }), data);
      csv = R.tail(csv);
      _this.setState({
        csv,
        csvError: errors.length === 0 ? null : errors
      })
    };
    let file = evt.target.files[0]
    if (file) {
      _this.setState({filename: file.name})
      reader.readAsText(evt.target.files[0]);
    }
  }

  onGPAClick() {
    let _this = this;
    this.setState({updating: true});
    let foundCount = 0, skipCount = 0;
    let studentObjs = R.mapObjIndexed((obj, key) => {
      obj.acGPA = '';
      obj.citGPA = '';
      return obj;
    }, this.props.studentObjs);
    R.forEach(line => {
      if (studentObjs[line.stuID]) {
        studentObjs[line.stuID].acGPA = line.acGPA;
        studentObjs[line.stuID].citGPA = line.citGPA;
        foundCount++;
      } else {
        skipCount++;
      }
    }, this.state.csv);
    this.props.db.ref('students').set(studentObjs, err => {
      _this.setState({
        updating: false,
        foundCount,
        skipCount
      });
      setTimeout(() => {
        _this.setState({foundCount: '', skipCount: ''})
      }, 5000);
    });
  };

  render() {
    return (
      <Form className="master-detail-top-separator push-footer">
        <FormGroup row>
          <Col md={4}>
            <label htmlFor="restoreFile" className="btn btn-secondary">Choose GPA file</label>
            <h5>{this.state.filename}</h5>
            {
              (this.state.csvError) ? <h5 class="csv-error">This file is not a GPA</h5> : null
            }
            <input id="restoreFile" name="file" accept=".csv, .tsv" type="file" onChange={this.onChange} />
          </Col>
          <Col md={2}>
            {
              (this.state.updating) ?
                <Button disabled={true} color="secondary">Updating...</Button> :
                <Button onClick={this.onGPAClick} disabled={this.state.csvError || !this.state.csv} color="secondary">Update</Button>
            }
          </Col>
          <Col md={6}>
            {
              (this.state.foundCount !== '') ?
                <h5>{this.state.foundCount} students updated; {this.state.skipCount} students not found</h5> :
                null
            }
          </Col>
        </FormGroup>
      </Form>
    )
  }
}

export default GPA;



// WEBPACK FOOTER //
// ./src/views/GPA.js